<div class="form-container" id="format-enseignements-form" appearance="outlined" data-tfa="creer_objet-maquette">
    <mat-card-title>
        <h2>Format des enseignements</h2>
    </mat-card-title>
    <mat-card-content [formGroup]="form.asFormGroup">
        <div class="structure-et-formation-porteuses">
            @if (form.asFormGroup.contains('formationPorteuse')) { @if (formationsPorteusesPossibles$ | async; as formations) {
            <mat-form-field>
                <mat-label>Formation porteuse</mat-label>
                <mat-select data-tfa="select-formation-porteuse" formControlName="formationPorteuse">
                    @for (f of formations; track f) {
                    <mat-option [value]="f.id" [attr.data-tfa]="'formation-porteuse-select_' + f.code">
                        {{ f.code }} {{ f.libelle }}
                    </mat-option>
                    }
                </mat-select>
                @if (!!form.asFormGroup.controls.formationPorteuse.value) {
                <mat-icon
                    matSuffix
                    data-tfa="empty-input-icon"
                    class="empty-input-icon"
                    aria-label="Réinitialiser la formation porteuse"
                    (click)="form.resetFormationPorteuse()"
                    >close</mat-icon
                >
                }
            </mat-form-field>
            } }
            <app-select-multiple-structures
                [name]="'structuresPorteuse'"
                [label]="'Structure porteuse'"
                [parent]="form.asFormGroup"
                [appEnableIfAutorise]="ODF_MODIFIER_FORMATS_ENSEIGNEMENT_OBJET_MAQUETTE"
                [structuresSansCodeUaiAutorisees]="true"
            ></app-select-multiple-structures>
        </div>
        @if (form.formatsEnseignementsArray.length > 0) {
        <form data-tfa="format-ens-table" [formGroup]="form.asFormGroup">
            @for (format of form.formatsEnseignementsArray.controls; track format; let i = $index) {
            <mat-card data-tfa="format-ens-card" [formGroup]="form.getFormArrayAtIndex(i)">
                <mat-card-header style="display: flex; justify-content: space-between;">
                    <app-select-nomenclature
                        mat-card-title
                        [formFieldStyles]="{ 'width': '150px' }"
                        class="form-field"
                        formControlName="typeHeure"
                        [getFullValueFn]="getNomenclatureFullValueFn"
                        label="Type d'heures"
                        [nomenclature]="NomenclatureType.TypeHeure"
                        [contexteConsommation]="espace()"
                        [isParametrage]="true"
                        [readonly]="true"
                        data-tfa="select_type_heure_formats_enseignements"
                        (click)="(true)"
                    ></app-select-nomenclature>
                    <button
                        data-tfa="supprimer-button"
                        class="delete-button"
                        mat-icon-button
                        color="accent"
                        (click)="form.formatsEnseignementsArray.removeAt(i); form.formatsEnseignementsArray.markAsDirty()"
                    >
                        <mat-icon data-tfa="icon-delete">delete</mat-icon>
                    </button>
                </mat-card-header>
                <mat-card-content class="format-ens-card__content">
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '180px' }"
                        class="form-field"
                        formControlName="typeHeure"
                        [getFullValueFn]="getNomenclatureFullValueFn"
                        label="Type d'heures"
                        [nomenclature]="NomenclatureType.TypeHeure"
                        [contexteConsommation]="espace()"
                        [isParametrage]="true"
                        data-tfa="select_type_heure_formats_enseignements"
                    ></app-select-nomenclature>
                    <app-select-nomenclature
                        [formFieldStyles]="{ 'width': '180px' }"
                        class="form-field"
                        formControlName="modalite"
                        [getFullValueFn]="getNomenclatureFullValueFn"
                        label="Modalité"
                        [nomenclature]="NomenclatureType.ModaliteEnseignement"
                        [contexteConsommation]="espace()"
                        [isParametrage]="true"
                        data-tfa="select_modalite_formats_enseignements"
                    ></app-select-nomenclature>
                    <div class="format-ens-card__line">
                        <mat-form-field class="input-form-field time-input" [floatLabel]="'always'">
                            <mat-label for="input-volumeHoraire">Volume horaire</mat-label>
                            <app-volume-horaire-input
                                #volumeHoraireInput
                                id="input-volumeHoraire_{{ i }}"
                                matTooltip="Volume horaire"
                                formControlName="volumeHoraire"
                            ></app-volume-horaire-input>
                            @if (volumeHoraireInput.parts.controls.minutes.hasError('max')) {
                            <mat-error>Format attendu : HHHH h MM</mat-error>
                            } @else {
                            <mat-error *appFormMatErrors="form.getFormArrayAtIndex(i).controls.volumeHoraire"></mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="format-ens-card__line">
                        <mat-form-field class="input-form-field">
                            <mat-label for="input-nombreTheoriqueDeGroupes">Nb. th de gp</mat-label>
                            <input
                                matInput
                                matTooltip="Nombre théorique de groupes"
                                data-tfa="input-nombreTheoriqueDeGroupes"
                                id="input-nombreTheoriqueDeGroupes_{{ i }}"
                                type="text"
                                maxlength="2"
                                formControlName="nombreTheoriqueDeGroupes"
                            />
                        </mat-form-field>
                        <mat-error *appFormMatErrors="form.getFormArrayAtIndex(i).controls.nombreTheoriqueDeGroupes"></mat-error>
                    </div>
                    <div class="format-ens-card__line">
                        <mat-form-field class="input-form-field">
                            <mat-label for="input-seuilDedoublement">Seuil dédoubl.</mat-label>
                            <input
                                matTooltip="Seuil de dédoublement"
                                matInput
                                id="input-seuilDedoublement_{{ i }}"
                                data-tfa="input-seuilDedoublement"
                                formControlName="seuilDedoublement"
                            />
                        </mat-form-field>
                        <mat-error *appFormMatErrors="form.getFormArrayAtIndex(i).controls.seuilDedoublement"></mat-error>
                    </div>
                </mat-card-content>
            </mat-card>
            }
        </form>
        }
        <button
            data-tfa="ajout-format-button"
            mat-raised-button
            [appEnableIfAutorise]="ODF_MODIFIER_FORMATS_ENSEIGNEMENT_OBJET_MAQUETTE"
            (click)="form.addFormatEnseignement()"
        >
            Ajouter un format
        </button>
        <div class="buttons-horizontal-container">
            <ng-content select="#bouton-fermer-objet-maquette"></ng-content>
            <button
                data-tfa="objet-maquette-créer-button"
                [disabled]="!form.isValid || form.isPristine"
                mat-raised-button
                color="primary"
                (click)="modifierChargesEnseignement()"
            >
                <mat-icon data-tfa="icone-valider">check</mat-icon>
                Enregistrer
            </button>
        </div>
    </mat-card-content>
</div>
